import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import "./RegisterPage.css";
// import { Navbar } from "react-bootstrap";
import Navbar from "./Navbar";
import Header from "./Header";
import host from "../config";
// import Header from "../components/Header";

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    otp: "",
    email: "",
    password: "",
    address: "",
    city: "",
    state: "",
    idProofType: "",
    idProofDetails: "",
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    let errorMessage = "";

    switch (name) {
      case "name":
        if (!value.trim()) {
          errorMessage = "Name is required.";
        }
        break;

      case "mobile":
        const isMobileValid = validateMobileNumber(value);
        if (!isMobileValid) {
          errorMessage =
            "Invalid mobile number. Please enter a 10-digit number.";
        }
        break;

      case "otp":
        if (!value.trim()) {
          errorMessage = "Please enter the OTP.";
        }
        break;
      case "email":
        if (!value.trim()) {
          errorMessage = "Email is required.";
        }
        break;

      case "password":
        if (!value.trim()) {
          errorMessage = "Password is required.";
        }
        break;
      case "address":
        if (!value.trim()) {
          errorMessage = "Address is required.";
        }
        break;

      case "city":
        if (!value.trim()) {
          errorMessage = "City is required.";
        }
        break;

      case "state":
        if (!value.trim()) {
          errorMessage = "State is required.";
        }
        break;

      case "idProofDetails":
        if (formData.idProofType === "Aadhar") {
          const isAadharValid = validateAadharNumber(value);
          if (!isAadharValid) {
            errorMessage =
              "Invalid Aadhar number. Please enter a 12-digit number.";
          }
        } else if (formData.idProofType === "Pancard") {
          const isPancardValid = validatePancard(value);
          if (!isPancardValid) {
            errorMessage =
              "Invalid Pancard. Please enter a 10-character combination of alphabets and numbers.";
          }
        }
        break;

      case "idProofType":
        setFormData({
          ...formData,
          idProofType: value,
          idProofDetails: "",
        });
        break;

      default:
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    setError(errorMessage);
  };

  const validateMobileNumber = (mobile) => {
    const mobileRegex = /^[0-9]{10}$/;
    return mobileRegex.test(mobile);
  };
  const validateAadharNumber = (aadhar) => {
    const aadharRegex = /^[0-9]{12}$/;
    return aadharRegex.test(aadhar);
  };

  const validatePancard = (pancard) => {
    const pancardRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    return pancardRegex.test(pancard);
  };

  const handleSendOtp = async () => {
    try {
      const isMobileValid = validateMobileNumber(formData.mobile);

      if (!formData.name.trim()) {
        setError("Name is required.");
      } else if (!isMobileValid) {
        setError("Invalid mobile number. Please enter a 10-digit number.");
      } else {
        setError(""); // Clear previous error
        const response = await axios.post(
          `${host}/usermobnumcheck`,
          {
            username: formData.name,
            mobile_number: formData.mobile,
          }
        );

        if (response.data.status === 200) {
          setOtpSent(true);
        } else {
          setError("Mobile Number Already Exists");
        }
      }
    } catch (error) {}
    console.error("Failed to send OTP:", error.message);
  };
  const handleVerifyOtp = async () => {
    try {
      const response = await axios.post(
        `${host}/userRegvfyotp`,
        {
          otp: formData.otp,
          username: formData.name,
          mobile_number: formData.mobile,
        }
      );

      if (response.data.status === 200) {
        setOtpVerified(true);
      } else {
        setError("Invalid OTP");
      }
    } catch (error) {
      console.error("Failed to verify OTP:", error.message);
    }
  };

  const handleRegister = async () => {
    // Check if all required fields are filled
    const requiredFields = ["name", "mobile", "email"];
    const missingFields = requiredFields.filter(
      (field) => !formData[field].trim()
    );

    if (missingFields.length > 0) {
      setError(
        `Please fill in the following fields: ${missingFields.join(", ")}`
      );
      return;
    }

    try {
      const response = await axios.post(
        `${host}/userRegister`,
        {
          mobile_number: formData.mobile,
          email_id: formData.email,
          name: formData.name,
        }
      );

      if (response.data.status === 200) {
        alert("Registration successful!");
        navigate("/login");
       
      } else {
        setError("Failed to register");
      }
    } catch (error) {
      console.error("Registration failed:", error.message);
    }
  };

  return (
    <div>
      {/* <Navbar /> */}
      <Header />

      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            <div className="login-form">
              <div className="card-body">
                <h1
                  className="text-center mb-4"
                  style={{ fontSize: "25px", color: "green" }}
                >
                  Register
                </h1>
                <form>
                  <div className="mb-3">
                    <label className="form-label">Name:</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <br />
                  <div className="mb-3">
                    <label className="form-label">Mobile Number:</label>
                    <input
                      type="text"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <br />
                  {!otpSent && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSendOtp}
                    >
                      Send OTP
                    </button>
                  )}
                  {otpSent && !otpVerified && (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">Enter OTP:</label>
                        <input
                          type="text"
                          name="otp"
                          value={formData.otp}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleVerifyOtp}
                        disabled={!formData.otp}
                      >
                        Verify OTP
                      </button>
                    </div>
                  )}
                  {otpVerified && (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">Email:</label>
                        <input
                          type="text"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleRegister}
                      >
                        Register
                      </button>
                    </div>
                  )}
                  {error && (
                    <div className="alert alert-danger mt-3">{error}</div>
                  )}
                </form>
                <br />
                <div className="mt-3">
                  <p>
                    If already registered, <Link to="/Login">Login here</Link>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
